import { useEffect, useRef } from "react";

/**
 * Adds the "is-visible" class to the element when it enters the viewport.
 * Pair with the `.reveal` class defined in index.css for a fade/translate-up effect.
 */
export const useReveal = (options = {}) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      node.classList.add("is-visible");
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            node.classList.add("is-visible");
            observer.unobserve(node);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px",
        ...options,
      },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [options]);

  return ref;
};
